import React, { useEffect, useState } from 'react';
import { Column } from 'styled/alignment/Column';
import CardProducerProfile from './parts/CardProducerProfile';
import AffiliateEntryCard from './parts/AffiliateEntryCard';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';
import producerProfilesApi from 'api/requests/producerProfiles';
import Loader from 'components/_UI/Loader';
import NotResultDashBoard from 'components/commons/NotResultDashBoard';
import Modal from 'components/_UI/Modal';
import ProducerProfileForm from './create/ProducerProfileForm';
import Text from 'components/_UI/Text';
import useToast from 'hooks/useToast';
import ToastContainer from 'components/_UI/ToastsContainer';

export default function ProducerProfile({ editProfileClick, onProfileLoaded = () => false }) {
  const [loader, setLoader] = useState(false);
  const [producerData, setProducerData] = useState(null);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { toast, toasts } = useToast();

  useEffect(() => {
    if (!editProfileClick) {
      getProducerData();
    }

    if (editProfileClick && producerData) {
      setIsEdit(producerData);
    }
  }, [editProfileClick]);

  async function getProducerData() {
    setLoader(true);
    try {
      const { data } = await producerProfilesApi.me();
      setProducerData(data?.data);
      onProfileLoaded(!!data?.data);
    } catch (error) {
      setProducerData(null);
      onProfileLoaded(false);
    } finally {
      setLoader(false);
    }
  }

  function onCloseCollapse() {
    setIsCreate(false);
    setIsEdit(false);
  }

  function onSuccess(text) {
    toast.success(`Perfil de produtor ${text} com sucesso!`);
    onCloseCollapse();
    getProducerData();
  }

  return (
    <>
      <ToastContainer toasts={toasts} />
      {loader ? (
        <Loader />
      ) : (
        <>
          {producerData ? (
            <ProfileContainer>
              <CardProducerProfile data={producerData} />
              <AffiliateEntryCard fullWidth />
            </ProfileContainer>
          ) : (
            <NotResultDashBoard
              ilustration={'adding-pin-in-map'}
              text={
                <>
                  <Text name='highlight'>Crie seu perfil de produtor</Text>
                  <Text>Complete seu perfil de produtor para começar a criar e gerenciar seus eventos na plataforma.</Text>
                </>
              }
              textButton={'Criar perfil de produtor'}
              onClick={() => setIsCreate(true)}
            />
          )}
        </>
      )}
      <Modal
        isOpen={!!(isCreate || isEdit)}
        onClose={onCloseCollapse}
        closeButton
        isCircularClose
        size='medium'
        childrenOverflowY='scroll'
      >
        <ProducerProfileForm
          onClose={onCloseCollapse}
          isEdit={isEdit}
          onSuccess={onSuccess}
        />
      </Modal>
    </>
  );
}

const ProfileContainer = styled(Column)`
  width: 100%;
  flex-wrap: wrap;
  @media screen and (min-width: ${breakpoints.lg}) {
    flex-direction: row;
  }
`;
